import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';
import { AuthProvider } from './context/auth-context.jsx';
import { adminApi } from './lib/admin-api/index.js';
import { loadRuntimeConfig } from './lib/runtime-config.js';
import { applyBrandingCssVariables, normalizeBranding, resolveAdminDocumentTitle } from './shared/branding/branding.jsx';
import './i18n.js';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import './index.css';
import './scss/react.scss';
import './shared/styles/app.scss';


const container = document.getElementById('root');
const root = createRoot(container);
function App() {
	let element = useRoutes(AppRoute);
	
	return element;
}

loadRuntimeConfig().then((runtimeConfig) => {
  adminApi.configureRuntime({ baseUrl: runtimeConfig.apiBaseUrl });
  const branding = normalizeBranding(runtimeConfig.branding);
  applyBrandingCssVariables(branding, document.documentElement);
  document.title = resolveAdminDocumentTitle(branding);

  root.render(
    <BrowserRouter>
      <AuthProvider>
    	 <App />
      </AuthProvider>
    </BrowserRouter>
  );
});
